// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../reason/next/Next.bs.js");
let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Container = require("../common/Components/Container.bs.js");
let PageTitle = require("../common/Components/PageTitle.bs.js");
let FeaturesV3 = require("../../reason/featureFlipper/FeaturesV3.bs.js");
let ProfilePage = require("./ProfilePage.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let PasswordPage = require("./PasswordPage.bs.js");
let LoggedInAgent = require("../../reason/common/UserSession/LoggedInAgent.bs.js");
let ViewPreferences = require("./ViewPreferences.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let SubusersPageRelay = require("./SubusersPageRelay.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let SettingsPageSidebar = require("./SettingsPageSidebar.bs.js");
let ReactErrorBoundary = require("react-error-boundary");
let BillingSettingsPageRelay = require("./BillingSettingsPageRelay.bs.js");
let EmailPreferencesPageRelay = require("./EmailPreferencesPageRelay.bs.js");
let CreateTeamMarketingProfile = require("./CreateTeamMarketingProfile.bs.js");
let EditMarketingProfileMember = require("./EditMarketingProfileMember.bs.js");
let UnifiedAccountSettingsPage = require("./UnifiedAccountSettingsPage.bs.js");
let AddMemberToMarketingProfile = require("./AddMemberToMarketingProfile.bs.js");
let TeamMarketingProfileSettings = require("./TeamMarketingProfileSettings.bs.js");
let TeamMarketingProfileSlugForm = require("./TeamMarketingProfileSlugForm.bs.js");
let AgentMarketingProfileSettings = require("./AgentMarketingProfileSettings.bs.js");
let AgentMarketingProfileSlugForm = require("./AgentMarketingProfileSlugForm.bs.js");
let TeamMarketingProfileAboutSettings = require("./TeamMarketingProfileAboutSettings.bs.js");
let AgentMarketingProfileAboutSettings = require("./AgentMarketingProfileAboutSettings.bs.js");
let TeamMarketingProfilePhotosSettings = require("./TeamMarketingProfilePhotosSettings.bs.js");
let AgentMarketingProfilePhotosSettings = require("./AgentMarketingProfilePhotosSettings.bs.js");
let TeamMarketingProfileMembersSettings = require("./TeamMarketingProfileMembersSettings.bs.js");
let TeamMarketingProfileBasicInfoSettings = require("./TeamMarketingProfileBasicInfoSettings.bs.js");
let AgentMarketingProfileBasicInfoSettings = require("./AgentMarketingProfileBasicInfoSettings.bs.js");
let TeamMarketingProfileSocialAccountsSettings = require("./TeamMarketingProfileSocialAccountsSettings.bs.js");
let AgentMarketingProfileSocialAccountsSettings = require("./AgentMarketingProfileSocialAccountsSettings.bs.js");

function AccountSettingsPage$LegacyPage(props) {
  let __setting = props.setting;
  let setting = __setting !== undefined ? __setting : ["profile"];
  let billingEnabled = UserSession.useChapterPreference("PayingChapter") === "ON";
  let tmp;
  if (setting.length !== 1) {
    tmp = "Settings";
  } else {
    let match = setting[0];
    switch (match) {
      case "billing" :
        tmp = "Billing Settings";
        break;
      case "email_notifications" :
        tmp = "Email Notifications Settings";
        break;
      case "password" :
        tmp = "Password Settings";
        break;
      case "preferences" :
        tmp = "Preferences";
        break;
      case "profile" :
        tmp = "Profile Settings";
        break;
      case "users" :
        tmp = "Users Settings";
        break;
      default:
        tmp = "Settings";
    }
  }
  let len = setting.length;
  let tmp$1;
  if (len >= 5) {
    tmp$1 = "This doesn't seem to be a valid URL";
  } else {
    switch (len) {
      case 0 :
        tmp$1 = "This doesn't seem to be a valid URL";
        break;
      case 1 :
        let match$1 = setting[0];
        switch (match$1) {
          case "billing" :
            tmp$1 = billingEnabled ? JsxRuntime.jsx(BillingSettingsPageRelay.make, {}) : "This doesn't seem to be a valid URL";
            break;
          case "email_notifications" :
            tmp$1 = JsxRuntime.jsx(EmailPreferencesPageRelay.make, {});
            break;
          case "marketing_profile" :
            tmp$1 = JsxRuntime.jsx(AgentMarketingProfileSettings.make, {});
            break;
          case "password" :
            tmp$1 = JsxRuntime.jsx(PasswordPage.make, {});
            break;
          case "preferences" :
            tmp$1 = JsxRuntime.jsx(ViewPreferences.make, {});
            break;
          case "profile" :
            tmp$1 = JsxRuntime.jsx(ProfilePage.make, {});
            break;
          case "team_marketing_profile" :
            tmp$1 = JsxRuntime.jsx(TeamMarketingProfileSettings.make, {});
            break;
          case "users" :
            tmp$1 = JsxRuntime.jsx(SubusersPageRelay.make, {});
            break;
          default:
            tmp$1 = "This doesn't seem to be a valid URL";
        }
        break;
      case 2 :
        let match$2 = setting[0];
        switch (match$2) {
          case "marketing_profile" :
            let match$3 = setting[1];
            switch (match$3) {
              case "about" :
                tmp$1 = JsxRuntime.jsx(AgentMarketingProfileAboutSettings.make, {});
                break;
              case "basic_info" :
                tmp$1 = JsxRuntime.jsx(AgentMarketingProfileBasicInfoSettings.make, {});
                break;
              case "photos" :
                tmp$1 = JsxRuntime.jsx(AgentMarketingProfilePhotosSettings.make, {});
                break;
              case "social_media" :
                tmp$1 = JsxRuntime.jsx(AgentMarketingProfileSocialAccountsSettings.make, {});
                break;
              case "url" :
                tmp$1 = JsxRuntime.jsx(AgentMarketingProfileSlugForm.make, {});
                break;
              default:
                tmp$1 = "This doesn't seem to be a valid URL";
            }
            break;
          case "team_marketing_profile" :
            let match$4 = setting[1];
            switch (match$4) {
              case "about" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfileAboutSettings.make, {});
                break;
              case "basic_info" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings.make, {});
                break;
              case "members" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfileMembersSettings.make, {});
                break;
              case "new" :
                tmp$1 = JsxRuntime.jsx(CreateTeamMarketingProfile.make, {});
                break;
              case "photos" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfilePhotosSettings.make, {});
                break;
              case "social_media" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfileSocialAccountsSettings.make, {});
                break;
              case "url" :
                tmp$1 = JsxRuntime.jsx(TeamMarketingProfileSlugForm.make, {});
                break;
              default:
                tmp$1 = "This doesn't seem to be a valid URL";
            }
            break;
          default:
            tmp$1 = "This doesn't seem to be a valid URL";
        }
        break;
      case 3 :
        let match$5 = setting[0];
        if (match$5 === "team_marketing_profile") {
          let match$6 = setting[1];
          if (match$6 === "members") {
            let match$7 = setting[2];
            tmp$1 = match$7 === "new" ? JsxRuntime.jsx(AddMemberToMarketingProfile.make, {}) : "This doesn't seem to be a valid URL";
          } else {
            tmp$1 = "This doesn't seem to be a valid URL";
          }
        } else {
          tmp$1 = "This doesn't seem to be a valid URL";
        }
        break;
      case 4 :
        let match$8 = setting[0];
        if (match$8 === "team_marketing_profile") {
          let match$9 = setting[1];
          if (match$9 === "members") {
            let memberId = setting[2];
            let match$10 = setting[3];
            tmp$1 = match$10 === "edit" ? JsxRuntime.jsx(EditMarketingProfileMember.make, {
                memberId: memberId
              }) : "This doesn't seem to be a valid URL";
          } else {
            tmp$1 = "This doesn't seem to be a valid URL";
          }
        } else {
          tmp$1 = "This doesn't seem to be a valid URL";
        }
        break;
    }
  }
  return JsxRuntime.jsxs(Container.make, {
    children: [
      JsxRuntime.jsx(PageTitle.make, {
        title: tmp
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(SettingsPageSidebar.make, {}),
            className: "col-span-12 md:col-span-4 lg:col-span-3 mb-8 md:mb-0"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
              FallbackComponent: _error => {
                let tmp;
                if (setting.length !== 1) {
                  tmp = "There was an error loading your settings. Please try again later.";
                } else {
                  let match = setting[0];
                  switch (match) {
                    case "marketing_profile" :
                    case "team_marketing_profile" :
                      tmp = "There was an error loading your marketing profile. Please try again later.";
                      break;
                    default:
                      tmp = "There was an error loading your settings. Please try again later.";
                  }
                }
                return JsxRuntime.jsx(Alert.$$Error.make, {
                  title: tmp,
                  className: "shadow-sm"
                });
              },
              children: tmp$1
            }),
            className: "col-span-12 md:col-span-8 lg:col-span-9"
          })
        ],
        className: "grid grid-cols-12 gap-x-4"
      })
    ]
  });
}

let LegacyPage = {
  make: AccountSettingsPage$LegacyPage
};

function AccountSettingsPage$Page(props) {
  let __setting = props.setting;
  let setting = __setting !== undefined ? __setting : ["profile"];
  let unifiedProfileSettingsEnabled = FeaturesV3.useIsUnifiedProfileSettingsEnabled();
  if (unifiedProfileSettingsEnabled !== undefined && unifiedProfileSettingsEnabled) {
    return JsxRuntime.jsx(UnifiedAccountSettingsPage.Page.make, {
      setting: setting,
      legacyPage: JsxRuntime.jsx(AccountSettingsPage$LegacyPage, {
        setting: setting
      })
    });
  } else {
    return JsxRuntime.jsx(AccountSettingsPage$LegacyPage, {
      setting: setting
    });
  }
}

let Page = {
  make: AccountSettingsPage$Page
};

function AccountSettingsPage$default(props) {
  let setting = props.setting;
  let setting$1 = (setting == null) ? undefined : Primitive_option.some(setting);
  let router = Next.useRouter();
  let isReady = Next.Router.isReady(router);
  React.useEffect(() => {
    if (isReady && (setting == null)) {
      Next.Router.replace("/account/profile", undefined, undefined, router);
    }
  }, [
    isReady,
    setting$1
  ]);
  if (isReady) {
    return JsxRuntime.jsx(LoggedInAgent.Provider.make, {
      children: JsxRuntime.jsx(AccountSettingsPage$Page, {
        setting: setting$1
      })
    });
  } else {
    return null;
  }
}

let $$default = AccountSettingsPage$default;

exports.LegacyPage = LegacyPage;
exports.Page = Page;
exports.default = $$default;
exports.__esModule = true;
/* Next Not a pure module */
